module.exports = __webpack_public_path__ + "img/sand-decal-27.15fb008e.png";